__turbopack_context__.v({
  "active": "V6eulW_active",
  "chatForm": "V6eulW_chatForm",
  "chatHint": "V6eulW_chatHint",
  "chatIcon": "V6eulW_chatIcon",
  "chatInput": "V6eulW_chatInput",
  "chatInputWrapper": "V6eulW_chatInputWrapper",
  "chatPanel": "V6eulW_chatPanel",
  "chatTeaser": "V6eulW_chatTeaser",
  "chatTeaserText": "V6eulW_chatTeaserText",
  "chatTeaserTitle": "V6eulW_chatTeaserTitle",
  "dualInput": "V6eulW_dualInput",
  "errorMessage": "V6eulW_errorMessage",
  "hero": "V6eulW_hero",
  "inputField": "V6eulW_inputField",
  "inputFieldWrapper": "V6eulW_inputFieldWrapper",
  "inputHint": "V6eulW_inputHint",
  "inputIcon": "V6eulW_inputIcon",
  "inputLabel": "V6eulW_inputLabel",
  "inputPanel": "V6eulW_inputPanel",
  "inputPrefix": "V6eulW_inputPrefix",
  "inputRow": "V6eulW_inputRow",
  "inputTab": "V6eulW_inputTab",
  "inputTabs": "V6eulW_inputTabs",
  "logoRotator": "V6eulW_logoRotator",
  "promptChip": "V6eulW_promptChip",
  "promptChips": "V6eulW_promptChips",
  "proofDivider": "V6eulW_proofDivider",
  "proofLabel": "V6eulW_proofLabel",
  "proofNumber": "V6eulW_proofNumber",
  "proofStat": "V6eulW_proofStat",
  "sendButton": "V6eulW_sendButton",
  "socialProof": "V6eulW_socialProof",
  "subtitle": "V6eulW_subtitle",
  "suggestedLabel": "V6eulW_suggestedLabel",
  "suggestedPrompts": "V6eulW_suggestedPrompts",
  "tagline": "V6eulW_tagline",
  "title": "V6eulW_title",
  "titleLine": "V6eulW_titleLine",
  "trustBadge": "V6eulW_trustBadge",
  "trustLogo": "V6eulW_trustLogo",
  "visuallyHidden": "V6eulW_visuallyHidden",
});
